import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getLgaDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (globalFunction.isNullOrEmpty(parameter)) {
    parameter = pageComponent.state.jobData.PptState;
  }
  let that = this;
  httpClient
    .get('Admin/Lga/GetSelectOptionList?state=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          componentDataSource.LgaId = data.data;
          sectionComponent.customForm.current?.setState({ componentDataSource });
          if (data.data.map(item => { return item.Value }).indexOf(sectionComponent.customForm.current?.formRef.current?.getFieldValue('LgaId')) < 0) {
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ LgaId: 0 });
          }
        }
      } else {
        globalFunction.handleResultError(data, this.props.pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, that.props.pageComponent);
    });
}

export function openMap({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mapShow: true });
}

export function openLandData({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  window.open(uie.href);
}

//Suburb 选择后快速填写数据
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldsValue({ PptSuburb: data.data.Name, PptPostcode: data.data.Postcode, LgaId: data.data.LgaId });
}
